import React, {useContext} from 'react';
import Header from '../../Utils/Header'
import Footer from '../../Utils/Footer'
import modificar from '../../images/login.png'
import CredencialesContext from '../../Context/CredencialesContext/CredencialesContext';

const Modificar = () => {

    const usuario = localStorage.getItem('usuario')

    if(usuario === "" || usuario === null){
        localStorage.clear();
        window.location.replace('/');
    }

    //EXTRAER CONTEXT LOGIN
    const credenciales = useContext(CredencialesContext);
    const { datos_modificar, alerta_modificar, alerta_modificar_str, Datos_Modificar_F, Enviar_Modificar_F, Alerta_Modificar_F, Alerta_Modificar_Str_F, alerta_modificar_class, Alerta_Modificar_Class_F  } = credenciales;
    
    const GetModificar = e =>{
        e.preventDefault();

        Datos_Modificar_F({
            ...datos_modificar,
            [e.target.name]: e.target.value
        })
    }

    const EnviarModificar = e =>{
        e.preventDefault();

        if(datos_modificar.old_password !== undefined && datos_modificar.old_password !== "" &&  datos_modificar.new_password !== undefined && datos_modificar.new_password !== "" && datos_modificar.new_password2 !== undefined && datos_modificar.new_password2 !== "" ){
            
            if(datos_modificar.new_password.length < 8){
                Alerta_Modificar_F(true)
                Alerta_Modificar_Str_F("Las contraseña debe ser de al menos 8 dígitos.")
                Alerta_Modificar_Class_F("alert alert-danger col-12 col-md-5 text-center my-2")
                return;
            }

            if(datos_modificar.new_password === datos_modificar.new_password2){
                Enviar_Modificar_F(true)
                Alerta_Modificar_F(false)
                document.getElementById('form-modificar').reset();
            }else{
                Alerta_Modificar_F(true)
                Alerta_Modificar_Str_F("Las contraseñas no son iguales.")
                Alerta_Modificar_Class_F("alert alert-danger col-12 col-md-5 text-center my-2")
            }
        
        }else{
            Alerta_Modificar_F(true)
            Alerta_Modificar_Str_F("Todos los campos son requeridos.")
            Alerta_Modificar_Class_F("alert alert-warning col-12 col-md-5 text-center my-2")
        }
        
    }
    return ( 

        <>
        <Header/>
            <div className="container-fluid bg-light py-5">
                <div className="row ">
                    <div className="col-12 col-md-6 d-none d-md-block mt-5">
                        <img src={modificar} alt="modificar" className="img-fluid mx-auto mt-5" />
                    </div>
                    <div className="col-12 col-md-6 ">
                        <h2 className="lead text-uppercase">modificar la contraseña</h2>
                        <form className="d-block" onSubmit={EnviarModificar} id="form-modificar">
                            <div className="form-group">
                                <label htmlFor="usuario">Contraseña Actual</label>
                                <input type="password" className="form-control col-12 col-md-5" onChange={GetModificar} name="old_password"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="usuario">Elige una nueva contraseña</label>
                                <input type="password" className="form-control col-12 col-md-5" onChange={GetModificar} name="new_password"/>
                            </div>
                            <div className="form-group">
                                <label htmlFor="usuario">Confirma la contraseña</label>
                                <input type="password" className="form-control col-12 col-md-5" onChange={GetModificar} name="new_password2"/>
                            </div>
                            <button type="submit" className="btn btn-primary mb-2 btn-send">Guardar</button>
                        </form>

                         {/* {enviar_recuperar ? 
                            <div className="spinner-grow text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        :null} */}

                        {alerta_modificar ? 
                            <div className={alerta_modificar_class} role="alert">
                                <strong>{alerta_modificar_str}</strong>
                            </div>
                        :null}

                    </div>
                </div>
            </div>
        <Footer/>
        </>
     );
}
 
export default Modificar;